module.exports = /* @ngInject */
(
    _,
    ReduxService,
    $q,
    $interpolate
) => {
    const result = {
        /**
         * Get the localization string from the redux store.
         * @param  {string} slug        localization slug
         * @param  {string} container   localization container name from Contentful
         * @param  {array}  params      the array of additional params for interpolation
         * @return {Object}             $q promise with the translation or the slug if no translation is found
         */
        getTranslation(slug, container, params) {
            return ReduxService.getState()
                .then((state) => {
                    const translation = _.get(state, `core.localizations.containers.${container}.${slug}`, undefined);

                    if (angular.isString(translation)) {
                        return $q.when(translation);
                    }

                    return $q.when(slug);
                });
        },

        /**
         * Interpolate a string with a list of variables.
         * Special numbered placeholders (%1, %2, etc.)
         * are used to make the substitutions with the
         * params value in the proper order. This is
         * accomplished by decrementing the params array
         * index based on parenthesized submatch number.
         * @param  {string} str    the string value of the slug
         * @param  {array}  params the array of params containing the data we want to substitute
         * @return {string}        param value
         */
        interpolateValues(str, params) {
            const interpolatedStr = str.replace(/%(\d+)/g, (match, positionIndex) => {
                return params[positionIndex - 1];
            });

            return interpolatedStr;
        }

    };

    return result;
};
